// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n@media (max-width:  768px) {\n  .col-md-3 {\n    margin-top: -20px;\n  }\n}\n*/", "",{"version":3,"sources":["webpack://./src/pages/user/CMProfile.vue"],"names":[],"mappings":"AACA;;;;;;CAAA","sourcesContent":["\n/*\n@media (max-width:  768px) {\n  .col-md-3 {\n    margin-top: -20px;\n  }\n}\n*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
